import React from "react";
import ReactDOM from "react-dom/client";
import { ClerkProvider } from "@clerk/react";
import "./index.css";
import "./styles/base.css";
import "./styles/menu.css";
import "./styles/scene-tree.css";
import "./styles/controls.css";
import "./styles/transform-gizmo.css";
import "./styles/viewport-toolbar.css";
import "./styles/camera-view-menu.css";
import "./styles/snap-tool.css";
import App from "./App.jsx";
import ErrorBoundary from "./components/ErrorBoundary.jsx";
import { getClerkPublishableKey } from "./cloud/clerkConfig";
import { initRuntimeErrorReporting } from "./monitoring/runtimeErrors.js";
import { initSentry } from "./monitoring/sentry.js";
import { logger } from "./utils/logger";

initSentry();
initRuntimeErrorReporting();

const shouldLoadAutomationApi =
  typeof window !== "undefined" &&
  (import.meta.env.VITE_ENABLE_AUTOMATION_API === "true" ||
    (import.meta.env.DEV &&
      new window.URLSearchParams(window.location.search).get("automationApi") === "1"));

if (shouldLoadAutomationApi) {
  void import("./automation/webDatasetRenderer");
}

if (import.meta.env.DEV) {
  import("./devtools/testBridge");
}

if (import.meta.env.DEV) {
  import("./devtools/gremlinsRunner").then(({ runGremlinsMonkeyTest }) => {
    window.runMonkeyTest = runGremlinsMonkeyTest;

    const monkeyParams = new window.URLSearchParams(window.location.search);
    if (monkeyParams.get("monkey") === "1") {
      const eventCount = Number(monkeyParams.get("monkeyEvents") ?? 250);
      window.runMonkeyTest({ eventCount });
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));

const clerkPublishableKey = getClerkPublishableKey();
if (!clerkPublishableKey && import.meta.env.DEV) {
  logger.warn("[auth] Missing VITE_CLERK_PUBLISHABLE_KEY; Clerk UI is disabled.");
}

const app = (
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

root.render(
  clerkPublishableKey ? (
    <ClerkProvider publishableKey={clerkPublishableKey}>{app}</ClerkProvider>
  ) : (
    app
  )
);
